import { create } from "zustand";
import {
  deleteData,
  getData,
  postData,
  putData,
} from "../../../../lib/utils/formHelpers";
import { CalibrationPatternSourceType } from "../../../types/report.types";
import { errorAlert, successAlert } from "../../../utils/alerts";
import { categorizeCalibrationPatternSources } from "./helpers";

type useCalibrationPatternSourceType = {
  calibrationPatternSourceList: CalibrationPatternSourceType[];
  save: (
    calibrationPatternSource: CalibrationPatternSourceType[],
    idCurrent: number
  ) => Promise<boolean>;
  fetchPreloadCalibrationPatternSource: (
    id: string
  ) => Promise<CalibrationPatternSourceType[]>;
  loading: boolean;
  loadingSave: boolean;
};

export const usecalibrationPatternSource =
  create<useCalibrationPatternSourceType>((set, get) => ({
    calibrationPatternSourceList: [],
    loading: false,
    loadingSave: false,
    fetchPreloadCalibrationPatternSource: async (id) => {
      set({ loading: true });
      try {
        const endpoint = `/calibration-pattern-source/filtered?calibration_tritium=${id}`;
        const { data: response } = await getData(endpoint);

        if (response) {
          const updatedResponse = response.map((calibration) => ({
            ...calibration,
            isotope: calibration.isotope.id,
          }));

          set({
            calibrationPatternSourceList: updatedResponse,
          });
          return updatedResponse;
        }
      } catch (error) {
        console.error("Error fetching entities:", error);
        errorAlert("Error al cargar los datos");
      } finally {
        set({ loading: false });
      }
    },

    save: async (calibrationPatternSource, idCurrent) => {
      set({ loadingSave: true });

      const {
        calibrationPatternSourceToNew,
        calibrationPatternSourceToUpdate,
        calibrationPatternSourceToDelete,
      } = categorizeCalibrationPatternSources(calibrationPatternSource);

      try {
        for (const newItem of calibrationPatternSourceToNew) {
          await postData("/calibration-pattern-source/create", {
            ...newItem,
            calibration_tritium: idCurrent,
          });
        }

        for (const updateItem of calibrationPatternSourceToUpdate) {
          await putData(
            `/calibration-pattern-source/${updateItem.id}/edit`,
            updateItem
          );
        }

        for (const deleteItem of calibrationPatternSourceToDelete) {
          await deleteData(`/calibration-pattern-source/${deleteItem.id}`);
        }

        successAlert("Cambios guardados correctamente");
        return true;
      } catch (error) {
        console.error("Error al guardar los cambios:", error);
        errorAlert("Error al guardar los cambios");
        return false;
      } finally {
        set({ loadingSave: false });
        /* get().fetchAll(); */
      }
    },
  }));
